import axios from 'axios';
import { authApi, isBrowser } from './utils';
import type Axios from 'axios';
import type { IConfig } from './interface';
import { IOptions } from './interface';

/**
 *
 * @param opts 请求的配置参数，包含fetch库的配置参数和axios本身
 * @param transformAuthApi 是否启用全量版对auth开头的api url进行配置参数的修改。除了全量版其他项目不需要，WTF business logic。
 */
export function service<T>(opts: IOptions<T>) {
  let start: number | null = null;
  return function (obj: IConfig) {
    const Sentry = opts?.Sentry;
    const service = axios.create(opts);
    if (Sentry && isBrowser()) {
      Sentry.setTag('request.method', obj?.method ?? 'get');
    }
    opts.modifyAxiosInstance && opts.modifyAxiosInstance(service, obj);
    service.interceptors.request.use(
      function (config) {
        if (Sentry && isBrowser()) {
          start = new Date().getTime();
          Sentry.setTag('request.url', obj?.url ?? '');
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    service.interceptors.response.use(
      function (response: Axios.AxiosXHR<any>) {
        if (Sentry && isBrowser()) {
          const duration = start ? new Date().getTime() - start : null;
          Sentry.setTag('request.duration', duration + '');
        }
        if (
          response.data.code !== 0 &&
          !opts?.ignoreUrlForErrTip?.includes(obj.url)
        ) {
          isBrowser() &&
            opts.errTipFn &&
            opts.errTipFn(response?.data?.message ?? response.data.msg);
          if (Sentry && isBrowser()) {
            Sentry.setTag(
              'request.errMsg',
              response?.data?.message ?? response.data.msg
            );
          }
        }
        return response.data;
      },
      function (error) {
        if (error.response?.data?.code !== 0) {
          isBrowser() &&
            opts.errTipFn &&
            opts.errTipFn(
              error?.response?.data?.message ?? error.response.data.msg
            );
        }
        if (Sentry && isBrowser()) {
          Sentry.setTag('request.errMsg', error.response.statusText || '');
        }
        return Promise.reject(error.response);
      }
    );
    const { method, params, ...rest } = obj;
    if (method?.toLowerCase() === 'post') {
      if (authApi.get('transform') || /^\/auth/g.test(obj.url)) {
        return service({
          ...rest,
          method: 'post',
          params,
        });
      }
      return service({
        ...rest,
        method: 'post',
        data: params,
      });
    }
    if (!method || method?.toLowerCase() === 'get') {
      return service({
        ...rest,
        method: method || 'get',
        params,
      });
    }
    return service(obj);
  };
}
